export const TypesChantier = {
  RACCORDEMENT_CLIENT: 'Raccordement client',
  MODIFICATION_OUVRAGE: 'Modification d’ouvrage',
  MODERNISATION_RESEAU: 'Modernisation du réseau',
};
